import ModalMinimalisteHPHC from './modals/minimaliste-hp-hc/modal-minimaliste-HP-HC'
import ModalDetailleeHPHC from './modals/detaillee-hp-hc/modal-detaillee-HP-HC'

require('../../core/require');
require('../../assets/scss/b2b-style.scss');
require('./page.scss');

export const modalMinimalisteHPHC = new ModalMinimalisteHPHC();
export const modalDetailleeHPHC = new ModalDetailleeHPHC();